// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2XlYM","questions":"styles_questions__3ozdx","footer":"styles_footer__igiyp"};